export default "__VITE_ASSET__UF4iDpNJhIbRdkaNqmNRqw__ 480w, __VITE_ASSET__z8IqaDpT53LmDJcH$tHz3g__ 768w, __VITE_ASSET__ffjd20BZfghNiCzGd8o8YQ__ 1122w";